<template>
  <b-container fluid class="padding-none">
    <ui-header />

    <button-logout class="logout" />
    <!-- als er een enkel product is en een imagelink -->
    <b-row
      v-if="(!products || products.length === 0) && imageLink !== ''"
      class="px-md-2 pr-md-4 pt-4 row-padding"
    >
      <b-col md="6">
        <div class="d-none d-md-block">
          <side-image />
        </div>
      </b-col>
      <b-col md="6" class="px-3 px-md-2 bottom-policy">
        <Loading ref="loader" v-show="!loaded" align-v="center" />
        <PostLoading
          ref="postloader"
          v-show="_postLoading && loaded"
          align-v="center"
        />
        <router-view v-show="loaded && !_postLoading" />
        <bottom-policies :onlyLogo="!loaded || _postLoading" />
      </b-col>
    </b-row>

    <!-- Als er een imagelink is en meerdere producten -->
    <b-row class="b-flex flex-wrap " v-else-if="imageLink !== ''">
      <b-col md="12" class="padding-none">
        <h4 class="text-center mt-4 font-weight-bold px-4">
          {{ $t("layout-product-perfect-size") }}
        </h4>
        <!--Picture grid-->
        <b-row class="d-flex flex-wrap" id="tailie-multi-products">
          <b-col
            md="4"
            class="p-10 mt-2"
            v-for="product in products"
            :key="product._id"
          >
            <div class="tailie-size-product">
              <transition name="fade">
                <b-img
                  class="h-80 m-10 fit-image top-image"
                  :src="product.imageLink"
                  fluid-grow
                />
              </transition>
              <b-img
                class="h-80 fit-image forced-top-left-placement"
                v-if="!product.imageLink"
                src="@/assets/images/product-image-not-found.jpg"
                fluid-grow
              />
              <h2>
                <span
                  v-if="product.match && product.match.STATUS == 'FULL FIT'"
                  >{{ product.match.SIZE }}</span
                >
                <span v-else><br /></span>
              </h2>
              <h6>{{ product.productName }}</h6>
            </div>
          </b-col>
        </b-row>
        <div class="px-4 mb-3 text-left">
          <last-measured />
        </div>
      </b-col>
    </b-row>

    <!-- Als er geen image is en wel een product -->
    <b-row class="h-100" v-else>
      <b-col md="12" class="b-flex padding-none">
        <!-- loading animation -->
        <Loading ref="loader" v-show="!loaded" align-v="center" />
        <PostLoading
          ref="postloader"
          v-show="_postLoading && loaded"
          align-v="center"
        />

        <router-view v-show="loaded && !_postLoading" />
      </b-col>

      <!-- footer -->
      <b-col md="12" class="padding-none" v-show="loaded">
        <bottom-policies :onlyLogo="!loaded || _postLoading" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Loading from "../../pages/product/loading";
import ButtonLogout from "../../components/ui/button-logout";
import PostLoading from "../../pages/product/post-loading";
import BottomPolicies from "../../components/ui/bottom-policies";
import LastMeasured from "../../components/ui/last-measured";
import UiHeader from "../../components/ui/app-header";
import SideImage from "../../components/ui/side-image";
import { mapGetters } from "vuex";

export default {
  name: "layouts-product",
  components: {
    Loading,
    PostLoading,
    ButtonLogout,
    BottomPolicies,
    LastMeasured,
    UiHeader,
    SideImage
  },
  data() {
    return {
      loaded: false,
      updated: false
    };
  },
  updated() {
    if (
      (this.$route.name === "match" ||
        this.$route.name === "match-group" ||
        this.$route.name === "match-multiple") &&
      !this.updated
    ) {
      this.updated = true;
      this.setLoaded(false);
      this.loader();
    }
  },
  mounted() {
    this.$store.commit("ui/SET_LOADING_ANIMATION_ACTIVE", true);
    this.loader();
  },
  computed: {
    ...mapGetters({
      imageLink: "pageParams/getImageLink",
      products: "pageParams/getProducts",
      _loading: "ui/loading",
      name: "users/getSelfFirstName",
      matchResult: "users/getSelfMatch",
      last_updated_at: "users/getSelfLastUpdated",
      contacts: "contacts/getContacts",
      userId: "users/getSelfId",
      activeBodyprint: "users/getSelfBodyPrint",
      matchableUserId: "application/getMatchableUserId"
    }),
    matchStatus() {
      if (
        this.matchResult === "FULL FIT" &&
        !this.productCombinations.find(
          c => c.size.toLowerCase() === this.matchSize.toLowerCase()
        )
      ) {
        return "NO FIT";
      }
      return this.matchResult;
    },
    _postLoading() {
      return (
        !!this.$store.state.ui.postLoadingText.length &&
        !!this.$store.state.ui.postLoadingAnimation.length
      );
    }
  },
  methods: {
    loader() {
      var _this = this;
      setTimeout(function() {
        _this.setLoaded(true);
        setTimeout(function() {
          _this.$store.commit("ui/RESET_POST_LOADING");
          setTimeout(function() {
            _this.updated = false;
          }, 300);
        }, 950);
      }, 800);
    },
    setLoaded(loaded) {
      if (loaded) {
        this.loaded = loaded;
        this.$store.commit("ui/SET_LOADING_ANIMATION_ACTIVE", !loaded);
      } else if (!loaded) {
        this.loaded = loaded;
        this.$store.commit("ui/SET_LOADING_ANIMATION_ACTIVE", !loaded);
      }
    }
  }
};
</script>

<style>
@media only screen and (max-width: 600px) {
  .row-padding {
    margin: 0 1rem 1rem 1rem;
  }
}

@media only screen and (min-width: 600px) {
  .row-padding {
    margin: 0 3rem 3rem 3rem;
  }
}

.bottom-policy {
  padding-bottom: 59px;
}

.logout {
  position: absolute;
  right: 0;
}

.logout .btn-link {
  margin-right: 41px;
  padding: 10px 0 0 0 !important;
}
</style>
